import { formatDate } from "utils/funcs"

export const isImageFile = (type: string) => type?.startsWith("image/")

export const validateAmount = (amount: string): string | null => {
    if (!amount) return "Please fill in amount"
    if (isNaN(parseFloat(amount))) return "Please enter a valid amount"
    return null
}

export const getOperationExpenses = (operation: any): any[] =>
    Array.isArray(operation?.expenses) ? operation.expenses : []

export const getExpensesTotal = (expenses: any[]): number =>
    expenses.reduce((sum: number, exp: any) => sum + (parseFloat(exp.amount) || 0), 0)

export const OPERATION_DETAIL_FIELDS: { key: string; label: string; format?: (v: any) => string }[] = [
    { key: "monthName", label: "Month" },
    { key: "badgeId", label: "Badge ID" },
    { key: "fullName", label: "Full Name" },
    { key: "submissionDate", label: "Submission Date", format: (v) => (v ? formatDate(v) : "Incomplete") },
    {
        key: "monthlyAllocation",
        label: "Monthly Allocation",
        format: (v) => `$${(parseFloat(v) || 0).toFixed(2)}`,
    },
    {
        key: "receiptsTotal",
        label: "Receipts Total",
        format: (v) => `$${(parseFloat(v) || 0).toFixed(2)}`,
    },
    {
        key: "approvedAmountToPay",
        label: "Approved Amount to Pay",
        format: (v) => `$${(parseFloat(v) || 0).toFixed(2)}`,
    },
]
